import { GlFormGroup, GlFormInput, GlDatepicker, GlFormTextarea, GlFormCharacterCount, GlModal, GlAlert, GlLink } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { convertToGraphQLId } from '~/graphql_shared/utils';
import { issuableTypeText, TYPE_ISSUE } from '~/issues/constants';
import { toISOStringWithoutMilliseconds } from '~/lib/utils/datetime_utility';
import { TYPENAME_ISSUE, TYPENAME_MERGE_REQUEST } from '~/graphql_shared/constants';
import { n__, s__, sprintf } from '~/locale';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import updateWorkItemTimeTrackingMutation from '~/work_items/graphql/update_work_item_time_tracking.mutation.graphql';
import { helpPagePath } from '~/lib/utils/path_helpers/help';
import createTimelogMutation from '../../queries/create_timelog.mutation.graphql';
import { CREATE_TIMELOG_MODAL_ID, SUMMARY_MAX_LENGTH } from './constants';
export default {
    name: 'CreateTimelogForm',
    components: {
        GlDatepicker,
        GlFormGroup,
        GlFormInput,
        GlFormTextarea,
        GlFormCharacterCount,
        GlModal,
        GlAlert,
        GlLink
    },
    mixins: [
        glFeatureFlagsMixin()
    ],
    inject: {
        issuableType: {
            default: null
        }
    },
    props: {
        issuableId: {
            type: String,
            required: false,
            default: ''
        },
        workItemId: {
            type: String,
            required: false,
            default: ''
        },
        workItemType: {
            type: String,
            required: false,
            default: ''
        }
    },
    data () {
        return {
            timeSpent: '',
            spentAt: null,
            summary: '',
            isLoading: false,
            saveError: ''
        };
    },
    computed: {
        modalText () {
            const issuableTypeName = issuableTypeText[this.issuableType || this.workItemType];
            return sprintf(s__('TimeTracking|Track time spent on this %{issuableTypeName}.'), {
                issuableTypeName
            });
        },
        submitDisabled () {
            return this.isLoading || this.timeSpent?.length === 0;
        },
        primaryProps () {
            return {
                text: s__('CreateTimelogForm|Save'),
                attributes: {
                    variant: 'confirm',
                    disabled: this.submitDisabled,
                    loading: this.isLoading
                }
            };
        },
        cancelProps () {
            return {
                text: s__('CreateTimelogForm|Cancel')
            };
        },
        timeTrackingDocsPath () {
            return helpPagePath('user/project/time_tracking.md');
        },
        createTimelogModalId () {
            return this.workItemId ? `${CREATE_TIMELOG_MODAL_ID}-${this.workItemId}` : CREATE_TIMELOG_MODAL_ID;
        }
    },
    methods: {
        resetModal () {
            this.isLoading = false;
            this.timeSpent = '';
            this.spentAt = null;
            this.summary = '';
            this.saveError = '';
        },
        close () {
            this.resetModal();
            this.$refs.modal.close();
        },
        remainingCountText (count) {
            return n__('%d character remaining.', '%d characters remaining.', count);
        },
        registerTimeSpent (event) {
            event.preventDefault();
            if (this.timeSpent?.length === 0) {
                return null;
            }
            this.isLoading = true;
            this.saveError = '';
            let isoSpentAt = null;
            if (this.spentAt) {
                const spentAtMidday = this.spentAt;
                spentAtMidday.setHours(spentAtMidday.getHours() + 12);
                isoSpentAt = toISOStringWithoutMilliseconds(spentAtMidday);
            }
            if (this.workItemId) {
                return this.$apollo.mutate({
                    mutation: updateWorkItemTimeTrackingMutation,
                    variables: {
                        input: {
                            id: this.workItemId,
                            timeTrackingWidget: {
                                timelog: {
                                    spentAt: isoSpentAt,
                                    summary: this.summary,
                                    timeSpent: this.timeSpent
                                }
                            }
                        },
                        useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField)
                    }
                }).then(({ data })=>{
                    if (data.workItemUpdate.errors.length) {
                        throw new Error(data.workItemUpdate.errors);
                    }
                    this.close();
                }).catch((error)=>{
                    this.saveError = error?.message || s__('TimeTracking|An error occurred while saving the time estimate.');
                }).finally(()=>{
                    this.isLoading = false;
                });
            }
            return this.$apollo.mutate({
                mutation: createTimelogMutation,
                variables: {
                    input: {
                        timeSpent: this.timeSpent,
                        spentAt: isoSpentAt,
                        summary: this.summary,
                        issuableId: this.getIssuableId()
                    }
                }
            }).then(({ data })=>{
                if (data.timelogCreate?.errors.length) {
                    this.saveError = data.timelogCreate.errors[0].message || data.timelogCreate.errors[0];
                } else {
                    this.close();
                }
            }).catch((error)=>{
                this.saveError = error?.message || s__('CreateTimelogForm|An error occurred while saving the time entry.');
            }).finally(()=>{
                this.isLoading = false;
            });
        },
        getGraphQLEntityType () {
            return this.issuableType === TYPE_ISSUE ? TYPENAME_ISSUE : TYPENAME_MERGE_REQUEST;
        },
        updateSpentAtDate (val) {
            this.spentAt = val;
        },
        getIssuableId () {
            return convertToGraphQLId(this.getGraphQLEntityType(), this.issuableId);
        }
    },
    SUMMARY_MAX_LENGTH
};
